export const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  dbDataBase: process.env.REACT_APP_DB_API,
  dataDatabase: process.env.REACT_APP_DB_DATA,
  businessIntelligenceUrl: process.env.REACT_APP_BEE_URL,
}
